import React from 'react'

import bannerCabecera from '../../imagenes/sobrePedraza/bg-sobre-pedraza.jpg'
import bannerCabecera2x from '../../imagenes/sobrePedraza/bg-sobre-pedraza@2x.jpg'
import imgSmall from '../../imagenes/sobrePedraza/img-small-1.png'
import imgSmall1x from '../../imagenes/sobrePedraza/img-small-1@2x.png'
import imgSmall2 from '../../imagenes/sobrePedraza/img-small-2.png'
import imgSmall2x from '../../imagenes/sobrePedraza/img-small-2@2x.png'
import facebook from '../../imagenes/sobrePedraza/redes/facebook.png'
import facebook2x from '../../imagenes/sobrePedraza/redes/facebook@2x.png'
import twitter from '../../imagenes/sobrePedraza/redes/twitter.png'
import twitter2x from '../../imagenes/sobrePedraza/redes/twitter@2x.png'
import instagram from '../../imagenes/sobrePedraza/redes/instagram.png'
import instagram2x from '../../imagenes/sobrePedraza/redes/instagram@2x.png'
import whatsapp from '../../imagenes/sobrePedraza/redes/whatsapp.png'
import whatsapp2x from '../../imagenes/sobrePedraza/redes/whatsapp@2x.png'
import youtube from '../../imagenes/sobrePedraza/redes/youtube.png'
import youtube2x from '../../imagenes/sobrePedraza/redes/youtube@2x.png'
import afip from '../../imagenes/sobrePedraza/compra-segura/afip.png'
import afip2x from '../../imagenes/sobrePedraza/compra-segura/afip@2x.png'
import argentina from '../../imagenes/sobrePedraza/compra-segura/argentina.png'
import argentina2x from '../../imagenes/sobrePedraza/compra-segura/argentina@2x.png'
//import verisign from '../../imagenes/sobrePedraza/compra-segura/verisign.png'
import thawte from '../../imagenes/sobrePedraza/compra-segura/thawte.png'
//import verisign2x from '../../imagenes/sobrePedraza/compra-segura/verisign@2x.png'
import thawte2x from '../../imagenes/sobrePedraza/compra-segura/thawte@2x.png'
//import clarin from '../../imagenes/sobrePedraza/logo_clarin.png'
//import capital from '../../imagenes/sobrePedraza/logo_capital.jpg'
import { Link } from 'react-router-dom'
import safeTravels from '../../imagenes/footer/safeTravels.png'

const Empresa = (props) => {

  window.scrollTo(0,0);

  return (
    <section>
    <section className="sobre-pedraza">
    <div className="container-fluid">
      <div className="row">
        <div className="bg col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <img src={bannerCabecera} alt="Imagen de un avi&oacute;n despegando"
            srcSet={bannerCabecera + ' 1x, ' + bannerCabecera2x + ' 2x'} />
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h1>Sobre <strong>Pedraza Viajes y Turismo S.A</strong></h1>
          <h6>Pedraza Viajes y Turismo S.A., es una Organizaci&oacute;n abocada a la Producción y Comercialización de Servicios Turísticos.</h6>
          <p>Desde sus inicios se ha especializado en la <strong>Prestación de Servicios Turísticos</strong> para al segmento de la Tercera Edad, hoy después de 20 años de trayectoria y de permanente desarrollo, amplia sus servicios para todos los que quieran <strong>disfrutar del placer de viajar</strong>.</p>
          <p>Esta orientación, sostenida y en permanente perfeccionamiento y actualización del Equipo empresarial; tanto del Nivel Directivo
          y de todos los Niveles que la constituyen; Desarrollo tecnológico y de herramientas orientadas a la calidad del servicio,
          le permiten ser considerada la más sólida y prestigiada en este mercado.</p>
          <p>La Gestión permanente nos ha permitido ir expandiendo nuestros servicios hacia una amplia zona geográfica. Capital Federal,
          Gran Buenos Aires, Localidades del Interior de la Provincia de Buenos Aires, Rosario, Gran Rosario, Córdoba Capital y localidades
          del interior de Córdoba.</p>
          <p>Atendemos una amplia y selecta clientela que nos permite brindarles una gama de servicios turísticos y cubrir las diversas
          expectativas de cada uno. Centros de Jubilados, Mutuales, Sindicatos, Obras Sociales, Agencias de Viajes, Familias, Amigos
          y Amigas, pueden disfrutar de nuestros servicios y sumarse a nuestra capacidad de generación empresarial.</p>
          <p>Contamos con información acerca del mercado que operamos, tenemos el conocimiento y los medios científicos y tecnológicos
          para seguir ampliándolo, disponemos de un prestigio que nos acredita como una empresa Seria, Sólida y Capaz de afrontar desafíos
          con éxito.</p>
          <p>Atentamente,</p>
          <p>Bernardo Pedraza <br />Presidente.</p>
        </article>
      </div>
    </div>
  </section>
  <section className="productos-pedraza">
    <div className="container">
      <div className="row">
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 big">
          <h6>Argentina 2018</h6>
          <h2>Productos Pedraza</h2>
          <p>Estos son algunos de los mejores productos que le ofrecemos a nuestros clientes para que puedan viajar y disfrutar del placer
          de conocer nuevas ciudades.</p>
        <Link to="/">ver m&aacute;s</Link>
        </div>
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 small-container">
          <div className="small">
            <div className="info-container">
              <h6>argentina 2018</h6>
              <h2>hoteles</h2>
              <p>
                Los hoteles mejor ubicados, con media pensión o pensión completa, todo a tu alcance.
              </p>
            </div>
            <div className="img-container">
              <img src={imgSmall} alt="Imagen de fondo acerca de viajes"
                srcSet={imgSmall + ' 1x, ' + imgSmall1x + ' 2x'} />
              <a href="http://www.pedraza.com.ar/cdr/index.php" target="_blank" rel="noopener noreferrer">ver m&aacute;s</a>
            </div>
          </div>
          <div className="small">
            <div className="img-container">
              <img src={imgSmall2} alt="Imagen de fondo acerca de viajes"
                srcSet={imgSmall2 + ' 1x, ' + imgSmall2x + ' 2x'} />
              <Link to="/">ver m&aacute;s</Link>
            </div>
            <div className="info-container">
              <h6>argentina 2018</h6>
              <h2>paquetes</h2>
              <p>
                Los paquetes ideales y al mejor precio para todo lo que estas buscando, todo en uno, listo para vos.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="social-media">
    <div className="container">
      <div className="row">
        <h3 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Encontr&aacute; a <strong>Pedraza</strong> en las Redes sociales</h3>
        <ul className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 row">
          <li className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="https://www.facebook.com/pedrazavyt/" target="_blank" rel="noopener noreferrer">
              <img src={facebook} alt="Icono de Facebook. Al clickearlo, iremos a la página de Facebook de Pedraza Viajes"
                srcSet={facebook + ' 1x, ' + facebook2x + ' 2x'} />
              <h6>Facebook</h6>
            </a>
          </li>
          <li className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="https://www.instagram.com/pedrazaviajes/" target="_blank" rel="noopener noreferrer">
              <img src={instagram} alt="Icono de Instagram. Al clickearlo, iremos a la página de Instagram de Pedraza Viajes"
                srcSet={instagram + ' 1x, ' + instagram2x + ' 2x'} />
              <h6>Instagram</h6>
            </a>
          </li>
          <li className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="https://twitter.com/pedrazaviajes" target="_blank" rel="noopener noreferrer">
              <img src={twitter} alt="Icono de Twitter. Al clickearlo, iremos a la página de Twitter de Pedraza Viajes"
                srcSet={twitter + ' 1x, ' + twitter2x + ' 2x'} />
              <h6>Twitter</h6>
            </a>
          </li>
          <li className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="https://api.whatsapp.com/send?phone=5491155822610&text=Escriba%20aqui%20su%20consulta" target="_blank" rel="noopener noreferrer">
              <img src={whatsapp} alt="Icono de Whatsapp. Al clickearlo, escribiremos a Pedraza Viajes"
                srcSet={whatsapp + ' 1x, ' + whatsapp2x + ' 2x'} />
              <h6>Whatsapp</h6>
            </a>
          </li>
          <li className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12">
            <a href="https://www.youtube.com/channel/UCIwK5lu2mw_QuQXyMboHa9Q" target="_blank" rel="noopener noreferrer">
              <img src={youtube} alt="Icono de Youtube. Al clickearlo, iremos a la página de Youtube de Pedraza Viajes"
                srcSet={youtube + ' 1x, ' + youtube2x + ' 2x'} />
              <h6>Youtube</h6>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
  <section className="diarios">
    <div className="container">
      <div className="row">
        <h3 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Contamos con el sello Safe Travels otorgado por la WTTC:</h3>
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 diarios-container">
			<img src={safeTravels} width="300" alt="Safe Travels" />
        </div>
      </div>
    </div>
  </section>
  {/*}<section className="diarios">
    <div className="container">
      <div className="row">
        <h3 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Mir&aacute; nuestras publicaciones en los diarios:</h3>
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 diarios-container">
          <img src={clarin} alt="Diario Clarin" width="200" />
          <img src={capital} alt="Diario La Capital de Rosario" width="200" />
        </div>
      </div>
    </div>
  </section>
*/}
  				
  {/*<section className="oficina">
    <div className="container">
      <div className="row">
        <h3 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">Visitanos en nuestra <strong>oficina</strong></h3>
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 map-container">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3284.0980924729834!2d-58.37748504951153!3d-34.60168098036405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccacc6871eb61%3A0x221547b8ff109e06!2sPedraza+Viajes+y+Turismo!5e0!3m2!1ses!2sar!4v1524351448972"
            frameBorder="0" style={{border: 0}} allowFullScreen title="Ubicacion de Pedraza"></iframe>
        </div>
      </div>
    </div>
  </section>*/}
  <section className="compra-segura">
    <div className="container">
      <div className="row">
        <h3 className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">En Pedraza tu compra es Segura</h3>
        <ul className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <li>
            <div className="logo-container" onClick={() => window.open("http://servicios.turismo.gob.ar/agencias/constancia/legajo/9998", '_blank')}>
              <img src={argentina} alt="Logo de Argentina"
                srcSet={argentina + ' 1x, ' + argentina2x + ' 2x'} />
            </div>
            <h6>Constancia de Licencia vigente online</h6>
          </li>
          <li>
            <div className="logo-container" onClick={() => window.open("http://qr.afip.gob.ar/?qr=SXlWug6BABWyZtxnVo-GHg,,", '_blank')}>
              <img src={afip} alt="Logo de Afip"
                srcSet={afip + ' 1x, ' + afip2x + ' 2x'} />
            </div>
            <h6>Constancia de AFIP</h6>
          </li>
          <li>
            <div className="logo-container">
              <img src={thawte} alt="Logo de Verisign"
                srcSet={thawte + ' 1x, ' + thawte2x + ' 2x'} />
            </div>
            <h6>Certificado Sitio seguro</h6>
          </li>
        </ul>
      </div>
    </div>
  </section>
  </section>
  )
}

export default Empresa



// WEBPACK FOOTER //
// ./src/components/Global/Empresa.js